/*
 * Marks an element as the inline-editable copy of one database value, so the
 * owner can click it in the preview and the edit saves back to that row.
 * Put it on the element that holds ONLY the raw value, never a formatted one.
 */
export const cms = (table: string, id: string | null | undefined, column: string): Record<string, string> => {
    return id ? { 'data-mdlfy-cms': `${table}:${id}:${column}` } : {}
}
